<!--抄表管理信息列表水表-->
<template>
  <div style="height: 100%;">
    <datePicker ref="datePicker" :initDate='nowSelectDate' :timeInterval="nowTimeInterval" type="custom"
      @selectTimeInterval="selectTimeInterval"></datePicker>
    <div style="height: 100%;">
      <div class="searchContainer">
        <el-form ref="form" label-width="87px" style="display: flex;align-items: center;">
          <el-form-item label="设备编号">
            <el-input v-model="deviceNo" placeholder="请输入设备编号" style="width:120px"></el-input>
          </el-form-item>

          <el-form-item label="设备名">
            <el-input v-model="findDeviceName" placeholder="请输入设备名" style="width:110px"></el-input>
          </el-form-item>

          <el-form-item label="业主姓名">
            <el-input v-model="ownerName" placeholder="请输入业主姓名" style="width:110px"></el-input>
          </el-form-item>
          <el-form-item label="抄表日期">
            <el-select v-model="DateDay" clearable placeholder="请选择" @change="selectDeductionFeeDay" style="width:87px">
              <el-option v-for="item in getDateDay" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开合闸状态">
            <el-select v-model="deviceStatus" clearable placeholder="请选择" @change="selectDeviceState232"
              style="width:90px">
              <el-option v-for="item in deviceStatusList" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开户状态">
            <el-select v-model="relevanceStatus" clearable placeholder="请选择" @change="selectRelevanceState"
              style="width:90px">
              <el-option v-for="item in relevanceStatusList" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联网状态">
            <div style="display: flex;align-items: baseline;">
              <el-select v-model="connectStatus" clearable placeholder="请选择" @change="selectDeviceState"
                style="width:90px">
                <el-option v-for="item in connectStatusList" :key="item.value" :label="item.text"
                  :value="item.value"></el-option>
              </el-select>
              <el-button type="primary" size="mini" @click="getDataList">查询</el-button>
              <el-button type="primary" size="mini" @click="addMeterSet">添加水表</el-button>
              <el-button type="primary" size="mini" @click="exportReport">报表导出</el-button>
            </div>
          </el-form-item>
          <!-- <el-form-item>
         
          </el-form-item> -->

        </el-form>
      </div>
      <!-- <div class="searchContainer">
        <div><label>设备编号</label><input type="text" v-model="deviceNo" maxlength="20" placeholder="请输入设备编号" /></div>
        <div><label>设备名</label><input type="text" v-model="findDeviceName" maxlength="20" placeholder="请输入设备名" /></div>
        <div><label>业主姓名</label><input type="text" v-model="ownerName" maxlength="20" placeholder="请输入业主姓名" /></div>
        <div style="margin-right: 10px;">
          <label>抄表日期</label>
          <el-select v-model="DateDay" clearable placeholder="请选择" @change="selectDeductionFeeDay">
            <el-option v-for="item in getDateDay" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </div>

        <div style="margin-right: 10px;">
          <label>开合闸状态</label>
          <el-select v-model="deviceStatus" clearable placeholder="请选择" @change="selectDeviceState232">
            <el-option v-for="item in deviceStatusList" :key="item.value" :label="item.text"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div style="margin-right: 10px;">
          <label>开户状态</label>
          <el-select v-model="relevanceStatus" clearable placeholder="请选择" @change="selectRelevanceState">
            <el-option v-for="item in relevanceStatusList" :key="item.value" :label="item.text"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div style="margin-right: 10px;">
          <label>联网状态</label>
          <el-select v-model="connectStatus" clearable placeholder="请选择" @change="selectDeviceState">
            <el-option v-for="item in connectStatusList" :key="item.value" :label="item.text"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <button @click="getDataList" style="width: 64px;">查询</button>
        <button @click="addMeterSet" style="width: 92px;">添加水表</button>
        <button @click="exportReport" style="width: 92px;">报表导出</button>
      </div> -->
      <!-- 
      <div class="custom-scrollbar infoListContainer">
        <div>
          <infoListMultipleSelection ref="meterManagerList" :totalSize="totalSize" :columns="columns"
            :dataList="dataList" :showSelection="false" @pageSizeChange="pageSizeChange" @jumpToPage="jumpToPage">
            <div slot="lastDeductionFeeTime" slot-scope="slotProps">
              <span>{{slotProps.item.deductionFeeDay}}号</span>
            </div>
            <div slot="amount" slot-scope="slotProps">
              <span>{{slotProps.item.amount / 100}}</span>
            </div>
            <div slot="ownerName" slot-scope="slotProps">
              <span>{{editOwnerName(slotProps.item.userName)}}</span>
            </div>
            <div slot='state' slot-scope="slotProps">
              <span class="wrongStatus" v-show="slotProps.item.state == 0">未开户</span>
              <span class="normalStatus"
                v-show="slotProps.item.state == undefined || slotProps.item.state == null">-</span>
              <span class="normalStatus" v-show="slotProps.item.state != 0">已开户</span>
            </div>
            <div slot='deviceState' slot-scope="slotProps">
              <span class="normalStatus" v-show="slotProps.item.deviceState == 1">在线</span>
              <span class="wrongStatus" v-show="slotProps.item.deviceState != 1">失联</span>
            </div>
            <div slot='state232' slot-scope="slotProps">
              <img :src="getDeviceStateSource(slotProps.item.state232)" alt="" />
            </div>
            <div slot="operate" slot-scope="slotProps">
              <span class="operateBtn" @click.stop="viewDetails(slotProps.item)">表管理</span>
              <span class="operateBtn" :class="{'noDrop':slotProps.item.deviceState != 1}"
                v-if="parseInt(slotProps.item.state232) == 0" @click="onOffState(slotProps.item,1)">关</span>
              <span class="operateBtn" :class="{'noDrop':slotProps.item.deviceState != 1}" v-else
                @click="onOffState(slotProps.item,0)">开</span>
              <span class="operateBtn marginRightNone" @click.stop="deleteMeter(slotProps.item)">删除</span>
            </div>
          </infoListMultipleSelection>
        </div>
      </div> -->

      <div class="infoListContainer">
        <el-table :data="dataList" max-height="750" border style="width: 100%;height: 94%;" v-loading="loading">
          <template slot="empty">
            <span class="noData">
              <img src="../../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" width="50" fixed>
          </el-table-column>
          <el-table-column fixed prop="deviceName" width="180" label="设备名称">
          </el-table-column>
          <el-table-column prop="deviceNo" label="设备编号" width="80">
          </el-table-column>
          <el-table-column prop="userName" label="业主姓名" width="100">
          </el-table-column>
          <el-table-column prop="deductionFeeDay" label="抄表日期" width="80">
            <template slot-scope="scope">
              <span>{{scope.row.deductionFeeDay}}号</span>
            </template>
          </el-table-column>
          <el-table-column prop="realElectricQuantity" label="实时用水量(m³)" width="130">
            <template slot-scope="scope">
              <span>{{scope.row.realElectricQuantity}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="realAmount" label="实时水费(元)" width="120">
            <template slot-scope="scope">
              <span>{{scope.row.realAmount /100}}</span>
            </template>
          </el-table-column>

          <el-table-column prop="amount" label="上月用水量(m³)" width="120">
            <template slot-scope="scope">
              <span>{{scope.row.electricQuantity}}</span>
            </template>
          </el-table-column>

          <el-table-column prop="amount" label="上月水费(元)" width="120">
            <template slot-scope="scope">
              <span>{{scope.row.amount /100}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="state" label="是否开户" width="100">
            <template slot-scope="scope">
              <span class="wrongStatus" v-show="scope.row.state == 0">未开户</span>
              <span class="wrongStatus" v-show="scope.row.state == -1">欠费中</span>
              <span class="normalStatus" v-show="scope.row.state == undefined || scope.row.state == null">-</span>
              <span class="normalStatus" v-show="scope.row.state == 1">已开户</span>
            </template>
          </el-table-column>

          <el-table-column prop="deviceState" label="联网状态" width="100">
            <template slot-scope="scope">
              <span class="normalStatus" v-show="scope.row.deviceState == 1">在线</span>
              <span class="wrongStatus" v-show="scope.row.deviceState != 1">离线</span>
            </template>
          </el-table-column>
          <el-table-column prop="state232" label="开合闸状态" width="100">
            <template slot-scope="scope">
              <img :src="getDeviceStateSource(scope.row.state232)" alt="" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="viewDetails(scope.row)" plain>表管理</el-button>
              <el-button size="mini" type="primary" v-if="scope.row.state232 != 0" @click="onOffState(scope.row,0)"
                plain>开</el-button>
              <el-button size="mini" type="danger" v-else @click="onOffState(scope.row,1)" plain>关</el-button>
              <el-button size="mini" type="danger" @click="deleteMeter(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <elPagination :total="totalSize" :pageSize="pageSize" @pageindexChange="jumpToPage"
          @handleSizeChange="pageSizeChange" />
      </div>


    </div>
    <VerifyPasswordDialog ref="verifyPasswordDialog"></VerifyPasswordDialog>
    <AddNewMeterDialog ref="addNewWaterMeterDialog" @successList="successList"></AddNewMeterDialog>
    <SelectChargeModeDialog ref="selectChargeModeDialog"></SelectChargeModeDialog>
  </div>
</template>

<script>
  import datePicker from '@/components/module/universal/datePicker.vue'
  import infoListMultipleSelection from '@/page/system/meterReading/infoListMultipleSelection.vue'
  import singleSelection from '@/components/module/selection/singleSelection.vue'
  import VerifyPasswordDialog from './dialogs/VerifyPasswordDialog.vue'
  import AddNewMeterDialog from './dialogs/AddNewMeterDialog.vue'
  import SelectChargeModeDialog from './dialogs/SelectChargeModeDialog.vue'
  import meterManagerStore from './meterManagerStore.js'
  import elPagination from "@/components/module/elComponents/elPagination.vue"
  import request from "@/api/http.js";
  export default {
    components: {
      datePicker,
      elPagination,
      infoListMultipleSelection,
      VerifyPasswordDialog,
      AddNewMeterDialog,
      SelectChargeModeDialog,
      singleSelection,
    },
    props: {},
    data () {
      return {
        loading: false,
        pageIndex: 1,
        pageSize: 20,
        totalSize: 0,
        dataList: [],
        deviceNo: '',
        findDeviceName: '',
        deviceName: '',
        ownerName: '',
        state: undefined,
        state232: undefined,
        deviceState: undefined,
        filterTime: false,
        searchChange: false,
        deductionFeeDay: '',
        meterType: "water",
        DateDay: "",
        deviceStatus: "",
        relevanceStatus: "",
        connectStatus: "",
      }
    },
    mounted () {
      console.log(this.columns,11);
      this.getDataList();
      meterManagerStore.commit('getAllMeterBillingMode',this.nowUnit.id);
    },
    computed: {
      getDateDay () {
        // console.log("日期",this.dateDay());
        return this.dateDay();
      },
      nowUser () {
        return this.$store.userStore.state.nowUserInfo
      },
      nowUnit () {

        return this.$store.unitStore.state.nowUnit
      },
      nowSelectDate () {
        return this.$store.cacheStore.getters.getNowSelectDate
      },
      nowTimeInterval () {
        return this.$store.cacheStore.getters.getMeterTimeInterval
      },
      nowDateText () {
        return this.filterTime? this.nowTimeInterval.startDate.formatByDate()+' - '+this.nowTimeInterval.endDate.formatByDate():''
      },
      columns () {

        return meterManagerStore.state.columns
      },
      editOwnerName () {
        return ownername => {
          return ownername==null||ownername==''||ownername==undefined? '-':ownername
        }
      },
      chargingStatusList () {
        return meterManagerStore.state.chargingStatusList
      },
      deviceStatusList () {
        return meterManagerStore.state.deviceStatusList
      },
      deviceStatusList () {
        return [{text: '请选择',value: ''},{text: '开闸',value: 0},{text: '合闸',value: 1}]
      },
      relevanceStatusList () {
        return [{text: '请选择',value: ''},{text: '未开户',value: 0},{text: '已开户',value: 1}]
      },
      connectStatusList () {
        return [{text: '请选择',value: ''},{text: '离线',value: 0},{text: '在线',value: 1}]
      },
      timeText () {
        return time => {
          if(time==null||time==undefined||time=='') {
            return '-'
          }
          return new Date(time).formatByDate()
        }
      },
      getDeviceStateSource () {
        return state => {
          if(parseInt(state)==0) {
            return this.$store.resourcesStore.getters.getResourcesByName('keli/state_on.png')
          } else if(parseInt(state)!=0) {
            return this.$store.resourcesStore.getters.getResourcesByName('keli/state_off.png')
          }
          //return this.$store.resourcesStore.getters.getResourcesByName('keli/state_no.png')
        }
      },
    },
    watch: {
      nowUser (nv,ov) {
        meterManagerStore.commit('setNowUser',nv)
      },
      nowUnit (nv,ov) {
        meterManagerStore.commit('setNowUnit',this.nv)
        this.getDataList(nv)
        meterManagerStore.commit('getAllMeterBillingMode',this.nowUnit.id,"second")

      },
      deviceNo (nv,ov) {
        this.searchChange=true
      },
      ownerName (nv,ov) {
        this.searchChange=true
      },
      state (nv,ov) {
        this.searchChange=true
      },
      deviceState (nv,ov) {
        this.searchChange=true
      },
      state232 (nv,ov) {
        this.searchChange=true
      },
      filterTime (nv,ov) {
        this.searchChange=true
      },
      nowTimeInterval (nv,ov) {
        this.searchChange=true
      }
    },
    methods: {
      pageindexChange () {

      },
      // 分页
      handleSizeChange () {

      },
      dateDay () {
        let list=[]
        for(let i=0;i<32;i++) {
          let obj={
            'text': i+'号',
            'value': i
          }

          if(i==0) {
            obj={
              'text': '请选择',
              'value': ''
            }
          }

          list.push(obj)
        }
        return list;
      },
      selectDeviceState232 (item) {
        // this.state232 = item.value
        this.state232=item
      },
      selectDeductionFeeDay (item) {
        // this.deductionFeeDay = item.value
        this.deductionFeeDay=item
      },
      selectRelevanceState (item) {
        // this.state = item.value
        this.state=item
      },
      selectDeviceState (item) {
        // this.deviceState = item.value
        this.deviceState=item
      },
      // 操作水表开关
      onOffState (item,state) {
        if(item.deviceState!=1) {
          return
        }
        //var state = parseInt(item.state232) == 1 ? 1 : 0
        this.$refs.verifyPasswordDialog.open('密码验证',password => {
          this.$api.meterReadingApi.controlMeter(item.userId,item.deviceNo,state,password,respon => {
            this.$set(item,'state232',state)
            this.$dialogMethod.showMessage('操作成功')
          },err => {
            this.$dialogMethod.showMessage(err)
          })
        })
      },
      viewDetails (item) {
        meterManagerStore.commit('setDeviceInfo',item)
        this.$emit('viewDetails',item)
      },
      // 删除水表
      deleteMeter (item) {
        this.$dialogMethod.openAgreeDialog("提示","确认删除设备名称："+item.deviceName+' 设备编号：'+item.deviceNo+' 的水表配置？',confirm => {
          this.$api.meterReadingApi.removeMeterReadingConfig(item.deviceNo,respon => {
            this.$dialogMethod.showMessage(respon)
            meterManagerStore.commit('getMeterReadingConfigList',this.nowUnit.id)
            this.getDataList()
          },err => {
            this.$dialogMethod.showMessage(err)
          })
        },cancel => {
          return
        },true)
      },
      successList () {
        this.getDataList()
      },
      // 获取抄表列表信息
      getDataList () {
        //debugger
        if(isempty(this.nowUnit)) {
          return
        }
        if(this.searchChange) {
          this.pageIndex=1
          this.$refs.meterManagerList.pageIndex=1
          this.searchChange=false
        }
        //var beginTime = this.filterTime ? this.nowTimeInterval.startDate.getTime() : undefined
        //var endTime = this.filterTime ? this.nowTimeInterval.endDate.getTime() : undefined
        // this.$api.meterReadingApi.getUnitMeterReadingConfigLimit(this.nowUnit.id, this.pageIndex, this.pageSize, this.deviceNo, this.ownerName, this.state, this.state232, this.deviceState, beginTime, endTime, respon => {
        // 	console.info(23424);
        // 	this.dataList = copy(respon.dataList.sort(this.compare('deviceName')))
        // 	this.totalSize = respon.total
        // 	this.$refs.meterManagerList.totalSize = respon.total
        // })
        //debugger
        this.$api.meterReadingApi.getUnitMeterReadingConfigLimit(this.nowUnit.id,this.pageIndex,this.pageSize,this.deviceNo,this.findDeviceName,this.ownerName,this.state,this.state232,this.deviceState,this.deductionFeeDay,this.meterType,respon => {
          //console.info(999);
          this.dataList=copy(respon.dataList.sort(this.compare('deviceName')))
          this.totalSize=respon.total

          //查询条件清空
          this.emptySerParam();
        })
      },

      emptySerParam () {
        this.deviceNo='';
        this.ownerName='';
        //this.dateDay();
        //this.state = 0;
        //this.deviceState = 0;
      },

      compare (name) {
        return function(a,b) {
          //debugger
          var s1=a[name];
          var s2=b[name];
          return s1.localeCompare(s2);
        }
      },

      // 添加水表配置
      addMeterSet () {
        this.$refs.addNewWaterMeterDialog.dialogFormVisible=true
      },
      // 导出报表
      exportReport () {
        // if(isempty(this.deductionFeeDay)) {
        //   this.$dialogMethod.showMessage('请选择抄表日期！')
        //   return
        // }
        var title=this.nowUnit.name+'水表信息'

        var params={
          unitid: this.nowUnit.id,
          meterRunType: this.meterRunType,
          deviceNo: this.deviceNo,
          ownerName: this.ownerName,
          deductionFeeDay: this.deductionFeeDay,
          accountType: this.accountType,
          meterType: this.meterType
        }

        // Get请求
        request({url: "/meterReading/exportUnitWaterMeterReadingConfig.do",method: "get",params}).then(res => {
          console.log(res,'res');
          saveAs(DWSystemSetting.downloadUrl+'/'+res.data,title+".xls")
        })

        // this.$api.meterReadingApi.exportUnitMeterReadingConfig(this.nowUnit.id,this.deviceNo,this.ownerName,this.state,this.deductionFeeDay,' ',this.meterType,respon => {
        //   saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
        // })
      },
      // 切换每页显示条数
      pageSizeChange (pageSize) {
        this.pageIndex=1
        this.pageSize=pageSize
        this.getDataList()
      },
      // 切换页码
      jumpToPage (pageIndex) {
        this.pageIndex=pageIndex
        this.getDataList()
      },
      // 选择时间区间的事件
      selectTimeInterval (timeInterval) {
        this.$store.cacheStore.commit('setMeterTimeInterval',timeInterval)
        this.$refs.datePicker.hide()
        this.filterTime=true
      },
    }
  }
</script>

<style scoped lang="scss">
  .searchContainer {
    padding: 10px 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  /deep/.el-input__inner {
    height: 36px;
    line-height: 36px;
  }

  .searchContainer>div {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    flex-grow: 0;
  }

  .searchContainer label {
    margin-right: 6px;
  }

  .searchContainer input {
    border-color: #DCDFE6;
    min-width: 130px;
    height: 36px;
    box-sizing: border-box;
    margin-right: 10px;
  }

  .searchContainer>>>.selection-body {
    display: inline-flex;
    padding: 0;
    margin-right: 20px;
  }

  .searchContainer>>>.selection>p {
    line-height: 34px;
    height: 34px;
    padding: 0;
  }

  .selectDateTime {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    width: 176px;
    height: 34px;
    padding: 0 6px;
    background: #FFFFFF;
    border-radius: 6px;
    border: solid 1px #DCDFE6;
    margin-right: 20px;
  }

  .selectDateTime>span {
    width: 140px;
    line-height: 34px;
    height: 100%;
    cursor: pointer;
  }

  .selectDateTime>img {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .searchContainer>button {
    height: 36px;
    background-color: #409EFF;
    color: #FFFFFF;
    padding: 0 18px;
    margin-left: 10px;
    border-radius: 4px;
    flex-shrink: 0;
    cursor: pointer;
  }

  .infoListContainer {
    padding: 0 0 20px 20px;
    height: calc(100% - 76px);
  }

  .infoListContainer::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .infoListContainer::-webkit-scrollbar-track {
    box-shadow: none;
    background-color: #FFFFFF;
  }

  .infoListContainer:hover::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F0F0F0;
  }

  .infoListContainer::-webkit-scrollbar-thumb {
    background-color: #FFFFFF;
  }

  .infoListContainer:hover::-webkit-scrollbar-thumb {
    background-color: #CACACA;
  }

  .infoListContainer>div {
    width: calc(100% - 10px);
  }

  .normalStatus {
    display: inline-block;
    border: solid 1px #87CF64;
    border-radius: 4px;
    color: #87CF64;
    background-color: #F0F9EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .wrongStatus {
    display: inline-block;
    border: solid 1px #F9A6A6;
    border-radius: 4px;
    color: #F9A6A6;
    background-color: #FEF1F1;
    line-height: 28px;
    padding: 0 6px;
  }

  .waitStatus {
    display: inline-block;
    border: solid 1px #E6A23C;
    border-radius: 4px;
    color: #E6A23C;
    background-color: #FDF6EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .normalStatus:hover,
  .wrongStatus:hover,
  .waitStatus:hover {
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
  }

  .operateBtn {
    display: inline-block;
    border-radius: 4px;
    line-height: 28px;
    padding: 0 6px;
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
    margin-right: 8px;
    cursor: pointer;
  }

  .noDrop {
    cursor: no-drop !important;
  }

  .marginRightNone {
    margin-right: 0;
    background-color: #f56e6e;
    color: #fff;
    border-color: #f56e6e;
  }

  /deep/table {
    border-top: 1px solid #DCDFE6;
    border-left: 1px solid #DCDFE6;

    th,
    td {
      border-right: 1px solid #DCDFE6;
    }
  }

  @media screen and (max-width: 1600px) {
    .searchContainer label {
      display: block;
      margin-right: 0;
    }

    .infoListContainer {
      height: calc(100% - 96px);
    }
  }
</style>